import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.search.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant } from "@/js/http/auth.js";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import { getErrorData } from "@/js/forms.js";
import { defaultPagingChoices, paging, creditNote, creditNoteUse, documentTypes } from "@/js/lists.ts";
import { getFullNameUser } from "@/js/user/user.js";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import Index from "@/components/paging/IndexComponent.vue";
import Paging from "@/components/paging/PagingComponent.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
import CreditNoteRefundDialog from "@/components/creditnote/CreditNoteRefundDialog.vue";
import CreditNoteModal from "@/components/creditnote/CreditNoteModal.vue";
import ManageDocumentsTagsDialog from "@/components/document-tags/ManageDocumentsTagsDialog.vue";
import AddTagToDocumentDialog from "@/components/document-tags/AddTagToDocumentDialog.vue";
export default {
  name: "CreditNoteListAdmin",
  components: {
    Paging: Paging,
    Index: Index,
    CreditNoteRefundDialog: CreditNoteRefundDialog,
    CreditNoteModal: CreditNoteModal,
    Confirm: Confirm,
    UploaderV2: UploaderV2,
    ManageDocumentsTagsDialog: ManageDocumentsTagsDialog,
    AddTagToDocumentDialog: AddTagToDocumentDialog
  },
  props: {
    searchCriterias: {
      paging: {
        limits: paging.DEFAULT,
        currentPage: 0,
        askedPage: 0
      },
      label: "",
      status: null,
      includeDeleted: false
    },
    loggedUserData: Object,
    filters: {
      default: false
    }
  },
  data: function data() {
    return {
      isLoading: true,
      isLoadingFiles: false,
      isStatelessDrawer: false,
      isFetchingCNFile: false,
      isDisabledCNFile: false,
      headers: [{
        text: "",
        value: "status",
        align: "center"
      }, {
        text: "Date",
        value: "creationDate",
        align: "center"
      }, {
        text: "C&M Reference",
        value: "numberLabel",
        align: "center"
      }, {
        text: "Imp. Reference",
        value: "issuingImporterRefs",
        align: "center"
      }, {
        text: "Extra description",
        value: "extraDescription",
        align: "center",
        width: "200px"
      }, {
        text: "Customer",
        value: "customer",
        align: "center"
      }, {
        text: "Origin",
        value: "origin",
        align: "center"
      }, {
        text: "Amount (incl VAT)",
        value: "totalAmountCurrency",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Remaining (incl VAT)",
        value: "remaining.amountCurrency",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Comment",
        value: "comment",
        align: "center",
        width: "200px"
      }],
      items: [],
      formSearch: {},
      numberOfPages: 0,
      creditNoteCount: null,
      pagingLimitsChoices: defaultPagingChoices,
      creditNoteDialogRefundShown: false,
      creditNoteModalShown: false,
      drawer: false,
      currentItem: null,
      filesCancelToken: axios.CancelToken.source(),
      isFetchingOrder: false,
      order: null,
      creditNote: creditNote,
      creditNoteUse: creditNoteUse,
      creditNoteStatus: Object.entries(creditNote.status).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (isNaN(key)) return acc;
        return [].concat(_toConsumableArray(acc), [{
          value: key,
          label: value.text
        }]);
      }, []),
      managedExceptions: {
        warning: {
          credit_note_already_deleted: "The credit note is already deleted.",
          credit_note_already_closed: "The credit note is already closed.",
          credit_note_already_canceled: "The credit note is already canceled.",
          credit_note_already_used: "Credit note is already used.",
          credit_note_in_used: "The credit note is in used.",
          credit_note_use_remaining_amount_invalid: "The remaining amount to refund is less than the desired amount.",
          credit_note_use_blocked_by_order: "To refund the desired amount, you must remove some uses on the associated order(s)."
        }
      },
      documentTypes: documentTypes
    };
  },
  computed: {
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/credit-notes/").concat(this.currentItem.id, "/files");
    },
    hasResult: function hasResult() {
      return !this.isLoading && this.items.length > 0;
    }
  },
  created: function created() {
    if (!isAdminNotConsultant(this.loggedUserData)) {
      this.$router.push({
        name: "userHome"
      });
      return;
    }
    this.formSearch = _objectSpread({}, this.searchCriterias);
    var filters = getFilters();
    if (filters !== null && filters !== void 0 && filters.creditNotes) {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), filters.creditNotes);
    }
    this.initCurrentItem();
    this.fetchCreditNotes();
  },
  methods: {
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    openUrl: function openUrl(url) {
      window.open(url, "_blank");
    },
    fetchOrder: function fetchOrder() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2$currentItem;
        var _this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.isFetchingOrder = true;
              _this2.order = null;
              if (!((_this2$currentItem = _this2.currentItem) !== null && _this2$currentItem !== void 0 && (_this2$currentItem = _this2$currentItem.fromOrder) !== null && _this2$currentItem !== void 0 && _this2$currentItem.id && _this2.currentItem.status === creditNote.status.DRAFT)) {
                _context.next = 8;
                break;
              }
              _this = _this2;
              _context.next = 6;
              return request("/v1/order/" + _this2.currentItem.fromOrder.id, "get", null, true, "api").then(function (response) {
                _this.order = response.data;
                _this.isFetchingOrder = false;
              }).catch(function (e) {
                _this.$toasted.show("Unable to load the order.", {
                  type: "error"
                });
                throw e;
              });
            case 6:
              _context.next = 9;
              break;
            case 8:
              _this2.isFetchingOrder = false;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchCN: function fetchCN() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isFetchingCNFile = true;

              //TODO : Be better, IssuingImporter vs CmIssuing
              _this = _this3;
              _context2.next = 4;
              return request("/v1/credit-notes/".concat(_this3.currentItem.id, "/files/cn"), "get", null, true, "api", null, _this3.filesCancelToken).then(function (response) {
                _this.currentItem = _objectSpread(_objectSpread({}, _this.currentItem), {}, {
                  url: response.data.value[0].url
                });
                _this.isDisabledCNFile = false;
              }).catch(function (e) {
                _this.isDisabledCNFile = true;
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to download the credit note's file.", {
                    type: "error"
                  });
                }
              });
            case 4:
              _this3.isFetchingCNFile = false;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchCreditNoteFiles: function fetchCreditNoteFiles() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this4;
              _this4.isLoadingFiles = true;
              _context3.next = 4;
              return request("/v1/credit-notes/".concat(_this4.currentItem.id, "/files"), "get", null, true, "api", null, _this4.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.isLoadingFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context3.sent;
              if (response) _this4.currentItem.files = _toConsumableArray(response.data);
              _this4.isLoadingFiles = false;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    upload: function upload() {
      this.fetchCreditNoteFiles();
    },
    removeFile: function removeFile(id) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.isStatelessDrawer = true;
              _context4.next = 3;
              return _this5.$refs.confirm.open("Cancel", "Are you sure you want to remove this file?", {
                color: "red"
              });
            case 3:
              confirmed = _context4.sent;
              if (!confirmed) {
                _context4.next = 10;
                break;
              }
              _this5.isLoadingFiles = true;
              _this = _this5;
              _context4.next = 9;
              return request("/v1/credit-notes/".concat(_this5.currentItem.id, "/files/").concat(id), "delete", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.isLoadingFiles = false;
              });
            case 9:
              if (!_this.isLoadingFiles) {
                _this5.fetchCreditNoteFiles();
              }
            case 10:
              _this5.digestStatelessDrawer();
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openTagsDialog: function openTagsDialog() {
      this.$refs.ManageDocumentsTagsDialog.openDialog();
    },
    openAddTagToDocument: function openAddTagToDocument(idDocument) {
      this.$refs.AddTagToDocumentDialog.openDialog(idDocument, this.documentTypes.CREDIT_NOTE);
    },
    removeTagFromDocument: function removeTagFromDocument(idDocument) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this6;
              _this.$refs.confirmDocumentDrawer.open("Delete", "Are you sure you want to delete this tag ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(confirm) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!confirm) {
                          _context5.next = 3;
                          break;
                        }
                        _context5.next = 3;
                        return request("/v1/document-tags/type/".concat(_this.documentTypes.CREDIT_NOTE.id), "delete", {
                          idDocument: idDocument
                        }, true, "api").then(function (response) {
                          _this.tagListChangedUpdate();
                        }).catch(function (error) {
                          _this.$toasted.show("Unable to remove tag from document.", {
                            type: "error"
                          });
                          throw error;
                        });
                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    tagListChangedUpdate: function tagListChangedUpdate() {
      this.fetchCreditNoteFiles();
      this.$refs.AddTagToDocumentDialog.fetchDocumentTags();
      this.$refs.ManageDocumentsTagsDialog.fetchDocumentTags();
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.numberOfPages) {
        this.formSearch.paging.askedPage = askedPage;
        this.fetchCreditNotes();
        window.scrollTo(0, 0);
      }
    },
    search: function search() {
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (isResetPaging) this.resetPaging();
      this.fetchCreditNotes();
    },
    resetPaging: function resetPaging() {
      this.formSearch.paging.askedPage = 0;
    },
    fetchCreditNotes: function fetchCreditNotes() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this = _this7;
              _this.isLoading = true;
              setFilters(function (state) {
                return _objectSpread(_objectSpread({}, state), {}, {
                  creditNotes: _this7.formSearch
                });
              });
              _this7.$EventBus.$emit("loading", true);
              _context7.next = 6;
              return request("/v1/credit-notes/all", "post", _this7.formSearch, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load current credit notes.", {
                  type: "error"
                });
                _this.$EventBus.$emit("loading", false);
                _this.isLoading = false;
                throw e;
              });
            case 6:
              response = _context7.sent;
              _this7.creditNoteCount = response.data.value.total_number;
              _this7.numberOfPages = Math.ceil(_this7.creditNoteCount / +_this7.formSearch.paging.limits);
              _this7.formSearch.paging.currentPage = _this7.formSearch.paging.askedPage + 1;
              _this7.items = response.data.value.items.map(function (x) {
                var _x$fromOrder;
                return _objectSpread(_objectSpread({}, x), {}, {
                  creationDate: x.creationDate && new Date(x.creationDate).toLocaleDateString("en-US"),
                  customer: x.user ? getFullNameUser(x.user) : x.importer.name,
                  fromOrderInvoiceNumber: (_x$fromOrder = x.fromOrder) === null || _x$fromOrder === void 0 ? void 0 : _x$fromOrder.invoiceNumberLabel
                });
              });
              _this7.$EventBus.$emit("loading", false);
              _this7.isLoading = false;
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    initCurrentItem: function initCurrentItem() {
      this.currentItem = {
        files: [],
        initialCurrency: "EUR",
        fromOrder: {
          id: null
        },
        remaining: {}
      };
      this.order = null;
    },
    digestStatelessDrawer: function digestStatelessDrawer() {
      var _this = this;
      setTimeout(function () {
        return _this.isStatelessDrawer = false;
      }, 1000);
    },
    clickOutsideDrawer: function clickOutsideDrawer() {
      if (this.isStatelessDrawer && !this.creditNoteDialogRefundShown) this.drawer = true;
    },
    selectItem: function selectItem(value) {
      this.currentItem = _objectSpread(_objectSpread({}, value), {}, {
        files: []
      });
      this.drawer = !this.drawer;
    },
    changeDrawer: function changeDrawer(value) {
      if (!value) {
        this.filesCancelToken.cancel();
        this.filesCancelToken = axios.CancelToken.source();
        return;
      }
      this.fetchCreditNoteFiles();
      if (this.currentItem.status === creditNote.status.DRAFT) {
        this.fetchOrder();
      } else {
        this.fetchCN();
      }
    },
    openCreditNoteModal: function openCreditNoteModal() {
      var _this8 = this;
      var isCreated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (isCreated) {
        this.initCurrentItem();
      }
      this.creditNoteModalShown = true;
      this.$nextTick(function () {
        _this8.$refs.CreditNoteModal.open();
      });
    },
    closeCreditNoteModal: function closeCreditNoteModal() {
      var _this9 = this;
      this.$nextTick(function () {
        _this9.initCurrentItem();
        _this9.creditNoteModalShown = false;
      });
    },
    closeAndReloadCreditNoteModal: function closeAndReloadCreditNoteModal() {
      var _this10 = this;
      this.$nextTick(function () {
        _this10.initCurrentItem();
        _this10.creditNoteModalShown = false;
        _this10.search(true);
      });
    },
    getToEditCreditNote: function getToEditCreditNote(value) {
      this.$router.push({
        name: "adminEditCreditNote",
        params: {
          id: value.id.toString(),
          searchCriterias: this.formSearch
        }
      });
    },
    deleteCreditNote: function deleteCreditNote() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this11.isStatelessDrawer = true;
              if (!(_this11.currentItem.status === _this11.creditNote.status.DRAFT)) {
                _context8.next = 7;
                break;
              }
              _context8.next = 4;
              return _this11.$refs.confirm.open("Delete", "Are you sure you want to delete this credit note ?", {
                color: "red"
              });
            case 4:
              confirmed = _context8.sent;
              _context8.next = 10;
              break;
            case 7:
              _context8.next = 9;
              return _this11.$refs.confirm.open("Cancel", "Are you sure you want to cancel this credit note ?", {
                color: "red"
              });
            case 9:
              confirmed = _context8.sent;
            case 10:
              if (!confirmed) {
                _context8.next = 20;
                break;
              }
              _this11.$EventBus.$emit("loading", true);
              _this = _this11;
              _context8.next = 15;
              return request("/v1/credit-notes/".concat(_this11.currentItem.id), "delete", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 15:
              _this11.search(true);
              _this11.isStatelessDrawer = false;
              _this11.initCurrentItem();
              _this11.drawer = false;
              _this.$EventBus.$emit("loading", false);
            case 20:
              _this11.digestStatelessDrawer();
            case 21:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    isInUsed: function isInUsed(item) {
      var _item$uses,
        _this12 = this;
      return (_item$uses = item.uses) === null || _item$uses === void 0 ? void 0 : _item$uses.some(function (x) {
        return x.status !== _this12.creditNoteUse.status.CANCELED;
      });
    },
    showCreditNoteRefundDialog: function showCreditNoteRefundDialog(value) {
      this.creditNoteDialogRefundShown = value;
      if (value) {
        this.isStatelessDrawer = true;
        this.drawer = false;
      } else {
        this.digestStatelessDrawer();
      }
    },
    addRefund: function addRefund(note, date, amountCurrency) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this, success;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this = _this13;
              success = true;
              _context9.next = 4;
              return request("/v1/credit-notes/".concat(_this13.currentItem.id, "/uses"), "post", {
                status: creditNoteUse.status.MANUAL_REFUND,
                refundingNote: note,
                amountCurrency: amountCurrency,
                vatRate: _this13.currentItem.initialVatRate,
                creationDate: date
              }, true, "api").catch(function (e) {
                success = false;
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this13.$EventBus.$emit("loading", false);
              });
            case 4:
              if (success) {
                _this13.showCreditNoteRefundDialog(false);
                _this13.search(true);
                _this13.isStatelessDrawer = false;
                _this13.initCurrentItem();
                _this13.drawer = false;
                _this13.$EventBus.$emit("loading", false);
                _this13.$toasted.show("Refund done.", {
                  type: "success"
                });
              }
              _this13.digestStatelessDrawer();
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    }
  }
};